export const DROP_ZONE_NAMES = {
  BROKER: 'Broker Files',
  CARRIER: 'Carrier Files',
};
